var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e36969",
    d: "M11.758 1.42h-2.88L8.057.597H3.944l-.823.823H.242v1.645h11.516zM1.065 13.758c0 .905.74 1.645 1.645 1.645h6.58a1.65 1.65 0 0 0 1.645-1.645v-9.87h-9.87z"
  })));
};
export default SvgTrash;